import React from 'react'
import RoomList from './roomList'
import { useState } from 'react'
import ChatBox from './chatBox'
import '../../../../css/public/dashboard/chatbox.css'

const Index = () => {
    const [selectedRoom, setSelectedRoom] = useState({
        id:0,
        userid:0,
        userimage:"",
        username:"",
        first:"",
        last:"",
        isUserA:false
    })
  return (
    <div className='fullchatbox_wrapper'>
      <div className='fullchatbox_container'>
        <RoomList selectedRoom={selectedRoom} setSelectedRoom={setSelectedRoom} />
        <ChatBox selectedRoom={selectedRoom} />
      </div>
    </div>
  )
}

export default Index
